module.exports = __webpack_public_path__ + "img/logo_header.50665ed6.svg";